var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"veille"},[_c('video',{attrs:{"src":"veille.mp4","muted":"","autoplay":"","loop":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }